<template>
  <div class="app-container">
    <Container
      :title="t('route.member')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="handleFilter"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <el-row>
          <el-col>
            <el-button
              v-if="$hasPermission(['SYS_USER_W'])"
              type="primary"
              size="large"
              style="margin-bottom: 10px"
              @click="handleCreate"
            >
              {{ t('common.append') }}
            </el-button>
          </el-col>
        </el-row>
        <el-table
          v-loading="listLoading"
          :data="list"
          border
          fit
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            :label="t('table.id')"
            align="center"
            prop="userId"
            width="100"
          />
          <el-table-column
            :label="t('dommonData.name')"
            prop="userName"
            align="center"
          />
          <el-table-column
            :label="t('user.loginUser')"
            align="center"
            prop="userAccount"
          />
          <el-table-column
            :label="t('user.department')"
            align="center"
            prop="department"
          />
          <el-table-column
            :label="t('user.roleNames')"
            align="center"
            prop="userRoleNames"
          />
          <el-table-column
            :label="t('user.mailAddress')"
            align="center"
            prop="mailAddress"
          />
          <el-table-column
            :label="t('user.isActive')"
            align="center"
            prop="active"
          >
            <template #default="{row}">
              <span>{{ row.active ? t('dommonData.active') : t('dommonData.notActive') }}</span>
            </template>
          </el-table-column>
          <!--<el-table-column
            :label="t('dommonData.createdAt')"
            align="center"
            prop="createdAt"
          >
            <template #default="{row}">
              <el-date-picker
                v-model="row.createdAt"
                type="datetime"
                readonly="true"
              />
            </template>
          </el-table-column>
          <el-table-column
            :label="t('dommonData.updatedAt')"
            class-name="status-col"
            prop="updatedAt"
          >
            <template #default="{row}">
              <el-date-picker
                v-model="row.updatedAt"
                type="datetime"
                readonly="true"
              />
            </template>
          </el-table-column>-->
          <el-table-column
            v-if="$hasPermission(['SYS_USER_W'])"
            :label="t('table.actions')"
            align="center"
            width="280"
            class-name="fixed-width"
          >
            <template #default="{row}">
              <el-button
                type="primary"
                size="mini"
                @click="handleUpdate(row)"
                style="min-width: 50px;"
              >
                {{ t('table.edit') }}
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="handleInitializePassword(row)"
                style="min-width: 50px;"
              >
                {{ t('user.changePasswordInitializeMessage') }}
              </el-button>
              <!--<el-button
                type="primary"
                size="mini"
                @click="handleUpdatePassword(row)"
                style="min-width: 50px;"
              >
                {{ t("user.updatePassword") }}
              </el-button>-->
              <!--<el-button
                v-if="row.active"
                size="mini"
                type="danger"
                @click="handleDelete(row.userId)"
                style="min-width: 50px;"
              >
                {{ t("table.delete") }}
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>

    <el-dialog
      v-if="$hasPermission(['SYS_USER_W'])"
      :title="t(textMap[dialogStatus])"
      v-model="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="tempUserModel"
        label-position="left"
        label-width="100px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item prop="userId">
          <el-input
            v-if="dialogStatus !== 'create'"
            v-show="false"
            v-model="tempUserModel.userId"
          />
        </el-form-item>

        <el-form-item
          v-if="dialogStatus !== 'updatePassword'"
          :label="t('dommonData.name')"
          prop="userName"
        >
          <el-input v-model="tempUserModel.userName" />
        </el-form-item>

        <el-form-item
          v-if="dialogStatus === 'create'"
          :label="t('user.loginUser')"
          prop="userAccount"
        >
          <el-input v-model="tempUserModel.userAccount" />
        </el-form-item>

        <el-form-item
          v-if="dialogStatus !== 'updatePassword'"
          :label="t('user.roleNames')"
          prop="userRoleNames"
        >
          <el-select
            v-model="tempUserModel.userRoleNames"
            class="filter-item"
            multiple
            :placeholder="t('form.selectPlaceholder')"
          >
            <el-option
              v-for="(item, index) in roleNameOptions"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="dialogStatus !== 'updatePassword'"
          :label="t('user.mailAddress')"
          prop="mailAddress"
        >
          <el-input v-model="tempUserModel.mailAddress" />
        </el-form-item>

        <el-form-item
          v-if="dialogStatus !== 'updatePassword'"
          :label="t('user.department')"
          prop="department"
        >
          <el-select
            v-model="tempUserModel.department"
            class="filter-item"
            :placeholder="t('form.selectPlaceholder')"
          >
            <el-option
              label="财务部"
              value="财务部"
            />
            <el-option
              label="采购部"
              value="采购部"
            />
            <el-option
              label="人事部"
              value="人事部"
            />
            <el-option
              label="管理团队"
              value="管理团队"
            />
            <el-option
              label="客服部"
              value="客服部"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          :label="t('dommonData.isActive')"
          prop="active"
        >
          <el-radio-group
            type="boolean"
            v-model="tempUserModel.active"
          >
            <el-radio :label="true">
              {{ t('dommonData.active') }}
            </el-radio>
            <el-radio :label="false">
              {{ t('dommonData.notActive') }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          v-if="dialogStatus !== 'update' && dialogStatus !== 'create'"
          :label="t('user.password')"
          prop="userPassword"
        >
          <el-input
            v-model="tempUserModel.userPassword"
            show-password
          />
        </el-form-item>

        <el-form-item
          v-if="dialogStatus !== 'update' && dialogStatus !== 'create'"
          :label="t('user.passwordConfirm')"
          prop="passwordConfirm"
        >
          <el-input
            v-model="tempUserModel.passwordConfirm"
            show-password
          />
        </el-form-item>
      </el-form>

      <div
        class="dialog-footer"
        style="text-align: right;"
      >
        <el-button @click="dialogFormVisible = false">
          {{ t('table.cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="dialogStatus === 'create' ? createData() : dialogStatus === 'update' ? updateData() : updatePassword()"
        >
          {{ t('table.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  onMounted,
  unref
} from 'vue'
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { createModel } from '@/utils/component'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import {
  getUserListForPage,
  createUser,
  updateUser,
  deleteUser,
  updateUserPassword, initializePassword
} from '@/apis/user'
import {
  getAllRoleNames
} from '@/apis/roles'
import {
  UserViewModel, UserPageParamModel, UserCreateModel, UserUpdateModel, UserUpdatePasswordModel
} from '@/model/userModel'
import { useI18n } from 'vue-i18n'
// import Pagination from '@/components/Pagination/index.vue'
export default defineComponent({
  name: 'Member',
  components: {
    SearchForm,
    Container
    // Pagination
  },
  setup() {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const searchStruct = [
      { prop: 'name', label: t('user.name'), component: 'el-input', type: 'text', model: '' },
      { prop: 'account', label: t('user.loginUser'), component: 'el-input', type: 'text', model: '' },
      { prop: 'department', label: t('user.department'), component: 'el-input', type: 'text', model: '' },
      {
        prop: 'active',
        label: t('dommonData.isActive'),
        component: 'el-select',
        model: true,
        options: [
          { label: t('dommonData.active'), value: true },
          { label: t('dommonData.notActive'), value: false }
        ]
      }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as any,
      tableKey: 0,
      list: Array<UserViewModel>(),
      total: 0,
      listLoading: true,
      page: 1,
      limit: 20,
      tempUserModel: {
        userId: null,
        userName: null,
        userRoleNames: [],
        userAccount: null,
        mailAddress: null,
        department: null,
        userPassword: null,
        passwordConfirm: null,
        active: true
      },
      roleNameOptions: Array<string>(),

      dialogFormVisible: false,
      dialogStatus: 'create',
      textMap: {
        update: 'user.edit',
        create: 'user.create',
        updatePassword: 'user.updatePassword'
      },
      passwordInitializedDialogVisible: false,
      // rules: {},
      async getRoleName() {
        const data = await getAllRoleNames()
        dataMap.roleNameOptions = data?.data ?? []
      },
      handleCurrentChange(page?: any) {
        dataMap.getList(page)
      },
      handleSizeChange(val: any) {
        dataMap.getList(null, val)
      },
      async getList(page?: any, limit?: any) {
        if (page) {
          dataMap.page = page
        }
        if (limit) {
          dataMap.limit = limit
        }

        dataMap.listLoading = true
        const params: UserPageParamModel = {
          userName: dataMap.searchFormModel.name,
          userRoleNames: null,
          userAccount: dataMap.searchFormModel.account,
          active: dataMap.searchFormModel.active,
          mailAddress: null,
          department: dataMap.searchFormModel.department,
          pageCurrent: dataMap.page,
          pageSize: dataMap.limit
        }

        const data = await getUserListForPage(params)
        dataMap.list = data?.data.list ?? []
        dataMap.total = data?.data.totalCount ?? 0

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      handleFilter() {
        dataMap.page = 1
        dataMap.getList()
      },
      handleCreate() {
        dataMap.dialogStatus = 'create'
        dataMap.dialogFormVisible = true
        nextTick(() => {
          (dataForm.value as typeof ElForm).resetFields()
          dataMap.tempUserModel.active = true
        })
      },
      createData() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const userCreateData: UserCreateModel = {
              userName: dataMap.tempUserModel.userName,
              userRoleNames: dataMap.tempUserModel.userRoleNames.join(','),
              userAccount: dataMap.tempUserModel.userAccount,
              mailAddress: dataMap.tempUserModel.mailAddress,
              department: dataMap.tempUserModel.department,
              userPassword: dataMap.tempUserModel.userPassword,
              active: dataMap.tempUserModel.active
            }
            const result = await createUser(userCreateData)
            if (result?.data && result?.data > 0) {
              ElMessage({
                message: t('user.createSuccessMessage'),
                type: 'success',
                duration: 2000
              })
              dataMap.dialogFormVisible = false
              await dataMap.getList()
            } else {
              ElMessage({
                message: result?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      },

      async handleUpdate(row: any) {
        dataMap.dialogStatus = 'update'
        dataMap.dialogFormVisible = true
        await nextTick(() => {
          (dataForm.value as typeof ElForm).resetFields()
        })
        dataMap.tempUserModel.userId = row.userId
        dataMap.tempUserModel.userName = row.userName
        dataMap.tempUserModel.userRoleNames = row.userRoleNames.split(',')
        dataMap.tempUserModel.mailAddress = row.mailAddress
        dataMap.tempUserModel.department = row.department
        dataMap.tempUserModel.active = row.active
      },
      updateData() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const userUpdateData: UserUpdateModel = {
              userId: dataMap.tempUserModel.userId,
              userName: dataMap.tempUserModel.userName,
              mailAddress: dataMap.tempUserModel.mailAddress,
              department: dataMap.tempUserModel.department,
              userRoleNames: dataMap.tempUserModel.userRoleNames.join(','),
              active: dataMap.tempUserModel.active
            }
            const result = await updateUser(userUpdateData)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            if (result?.data && result?.data > 0) {
              ElMessage({
                message: t('user.editSuccessMessage'),
                type: 'success',
                duration: 2000
              })
            } else {
              ElMessage({
                message: result?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      },
      async handleUpdatePassword(row: any) {
        dataMap.dialogStatus = 'updatePassword'
        dataMap.dialogFormVisible = true

        await nextTick(() => {
          (dataForm.value as typeof ElForm).resetFields()
        })
        dataMap.tempUserModel.userId = row.userId
      },
      updatePassword() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const userUpdatePassword: UserUpdatePasswordModel = {
              newUserPassword: dataMap.tempUserModel.userPassword
            }
            const result = await updateUserPassword(dataMap.tempUserModel.userId, userUpdatePassword)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            if (result?.data && result?.data > 0) {
              ElMessage({
                message: t('user.editSuccessMessage'),
                type: 'success',
                duration: 2000
              })
            } else {
              ElMessage({
                message: result?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      },
      handleDelete(userId: number) {
        ElMessageBox.confirm(t('user.deleteTipMessage'), t('message.tip'), {
          confirmButtonText: t('message.confirm'),
          cancelButtonText: t('message.cancel'),
          type: 'warning'
        }).then(async() => {
          await dataMap.deleteData(userId)
        }).catch(() => {
          ElMessage({
            type: 'info',
            message: t('user.cancelDeleteMessage'),
            duration: 2000
          })
        })
      },
      async deleteData(userId: number) {
        const result = await deleteUser(userId)
        dataMap.getList()
        if (result?.data && result?.data > 0) {
          ElMessage({
            message: t('user.deleteMessage'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.msg,
            type: 'error',
            duration: 2000
          })
        }
      },
      async handleInitializePassword(row: any) {
        ElMessageBox.confirm(t('user.confirmChangePasswordMessage'), t('message.tip'), {
          confirmButtonText: t('message.confirm'),
          cancelButtonText: t('message.cancel'),
          type: 'warning'
        }).then(async() => {
          await dataMap.onInitializePassword(row.userId)
        }).catch(() => {
          ElMessage({
            type: 'info',
            message: t('user.cancelPasswordInitializedMessage'),
            duration: 2000
          })
        })
      },
      async onInitializePassword(userId: number) {
        const result = await initializePassword(userId)
        dataMap.getList()
        if (result?.data && result?.data > 0) {
          ElMessage({
            message: t('user.passwordInitializedMessage'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.msg,
            type: 'error',
            duration: 2000
          })
        }
      },
      resetForm() {
        console.log('reset')
      }
    })
    const validatePassConfirm = (rule: any, value: any, callback: any) => {
      if (value !== dataMap.tempUserModel.userPassword) {
        callback(new Error(t('form.passwordNotMatch')))
      } else {
        callback()
      }
    }
    const rules = {
      userName: [
        { required: true, message: t('dommonData.name').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      userRoleNames: [
        { required: true, message: t('user.roleNames').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      userAccount: [
        { required: true, message: t('user.account').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      userPassword: [
        { required: true, message: t('user.password').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      passwordConfirm: [
        { required: true, message: t('user.passwordConfirm').concat(t('form.isRequired')), trigger: 'blur' },
        { validator: validatePassConfirm, trigger: 'blur' }
      ],
      mailAddress: [
        { required: true, message: t('user.mailAddress').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      department: [
        { required: true, message: t('user.department').concat(t('form.isRequired')), trigger: 'blur' }
      ]
    }
    onMounted(() => {
      dataMap.getRoleName()
      dataMap.getList(null, 20)
    })
    return {
      t,
      ...toRefs(dataMap),
      dataForm,
      rules
    }
  }
})
</script>
